import(/* webpackMode: "eager", webpackExports: ["SidebarDesktop","SidebarMobile"] */ "/vercel/path0/apps/web/src/app/(cms)/faq/components/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "/vercel/path0/packages/ui/dist/components/breadcrumb.js");
